// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__gmK72","highligthed":"Header_highligthed__vnp7G"};